import layer from "vue-layer-mobile";
import axios from "axios";
const AlertFZ = {};
(AlertFZ.AlertMsg = function(msg) {
  layer.toast({
    icon: "icon-check",
    content: msg,
    time: 5000
  });
}),
  (AlertFZ.AxiosFZ = function(url, params) {
    layer.loading("加载中...");
    let _this = this;
    axios
      .get(
        "http://180.76.145.81:8080/DFWMS/WDBService/TServerMethods/" +
          url +
          "/" +
          params
      )
      .then(function(response) {
        layer.close();
        return response;
      });
  });

export default AlertFZ;



// WEBPACK FOOTER //
// ./src/common/js/AlertFZ.js